var _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMobilemenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-menu",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 21,
    y2: 12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 21,
    y2: 6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 18,
    x2: 21,
    y2: 18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobilemenu);
export default __webpack_public_path__ + "static/media/icon-mobilemenu.955e7822c28f96c64fcc6e457ce01b8d.svg";
export { ForwardRef as ReactComponent };